<div class="sign-up-container justify-content-center align-items-center min-vh-100 mt-4">
    <div class="container">
        <div class="row justify-content-center">
            <!-- Left: User Details & Tier -->
            <div class="col-12 col-lg-6 d-flex align-items-center justify-content-center">
                <mat-card class="mat-elevation-z2 bg-white rounded" style="width:1000px;margin:auto; position:relative; max-height:90vh; overflow-y:auto;">
                    <mat-progress-bar *ngIf="isLoading" mode="indeterminate" style="position:absolute;top:0;left:0;width:100%;z-index:10;"></mat-progress-bar>
                    <mat-horizontal-stepper [linear]="true" #stepper>
                        <!-- Step 1: Account Info -->
                        <mat-step [stepControl]="accountForm">
                            <form [formGroup]="accountForm">
                                <ng-template matStepLabel>Account Information</ng-template>
                                <div class="text-center mb-3">
                                    <img src="assets/img/golftech-v2.png" alt="GolfTech Logo"
                                        style="max-width:300px; width:100%; height:auto;" />
                                </div>
                                <mat-form-field appearance="outline" class="w-100 mb-3">
                                    <mat-label>First Name</mat-label>
                                    <input matInput formControlName="given_name" required>
                                    <mat-error *ngIf="accountForm.get('given_name')?.hasError('required')">First Name is required</mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-100 mb-3">
                                    <mat-label>Last Name</mat-label>
                                    <input matInput formControlName="family_name" required>
                                    <mat-error *ngIf="accountForm.get('family_name')?.hasError('required')">Last Name is required</mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-100 mb-3">
                                    <mat-label>Email</mat-label>
                                    <input matInput formControlName="email" type="email" required>
                                    <mat-error *ngIf="accountForm.get('email')?.hasError('required')">Email is required</mat-error>
                                    <mat-error *ngIf="accountForm.get('email')?.hasError('email')">Invalid email</mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-100 mb-3">
                                    <mat-label>Password</mat-label>
                                    <mat-icon matSuffix (click)="showPassword = !showPassword">{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                                    <input matInput formControlName="password" [type]="showPassword ? 'text' : 'password'" required>
                                    <mat-error *ngIf="accountForm.get('password')?.hasError('required')">Password is required</mat-error>
                                    <mat-error *ngIf="accountForm.get('password')?.hasError('minlength')">Password must be at least 6 characters</mat-error>
                                </mat-form-field>
                                <div class="d-flex justify-content-end">
                                    <button mat-raised-button matStepperNext [disabled]="!accountForm.valid">Next</button>
                                </div>
                            </form>
                        </mat-step>

                        <!-- Step 2: Billing & Plan -->
                        <mat-step [stepControl]="billingForm">
                            <form [formGroup]="billingForm" (ngSubmit)="submit()" class="mt-1">
                                <ng-template matStepLabel>Billing & Subscription</ng-template>
                                <mat-form-field appearance="outline" class="w-100 mb-3">
                                    <mat-label>Address</mat-label>
                                    <input matInput formControlName="address" required>
                                    <mat-error *ngIf="billingForm.get('address')?.hasError('required')">Address is required</mat-error>
                                </mat-form-field>
                                <div class="row mb-3">
                                    <div class="col-md-6">
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>City</mat-label>
                                            <input matInput formControlName="city" required>
                                            <mat-error *ngIf="billingForm.get('city')?.hasError('required')">City is required</mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>State</mat-label>
                                            <mat-select formControlName="state" required>
                                                <mat-option *ngFor="let state of states" [value]="state.abbreviation">
                                                    {{ state.name }} ({{ state.abbreviation }})
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="billingForm.get('state')?.hasError('required')">State is required</mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <mat-form-field appearance="outline" class="w-100 mb-3">
                                    <mat-label>Zip</mat-label>
                                    <input matInput formControlName="zip" required type="number">
                                    <mat-error *ngIf="billingForm.get('zip')?.hasError('required')">Zip is required</mat-error>
                                    <mat-error *ngIf="billingForm.get('zip')?.hasError('min')">Zip must be 5 digits</mat-error>
                                    <mat-error *ngIf="billingForm.get('zip')?.hasError('max')">Zip must be 5 digits</mat-error>
                                </mat-form-field>
                                <div class="mb-3">
                                    <label class="mb-2 fw-bold">Select a Tier</label>
                                    <mat-radio-group formControlName="plan" class="w-100" (change)="onPlanChange()">
                                        <mat-radio-button *ngFor="let plan of plans" [value]="plan.id" class="d-block mb-2">
                                            <span>{{ plan.name }}</span><br />
                                            <span>{{ plan.description }}</span>
                                        </mat-radio-button>
                                    </mat-radio-group>
                                    <mat-error *ngIf="billingForm.get('plan')?.hasError('required')">Tier is required</mat-error>
                                </div>
                                <div class="mb-3">
                                    <label class="mb-2 fw-bold">Number of Simulators</label>
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Simulator Count</mat-label>
                                        <input matInput formControlName="simulatorCount" type="number" 
                                               [min]="1" [max]="getMaxSimulatorCount()" required>
                                        <mat-hint>Maximum allowed: {{ getMaxSimulatorCount() }}</mat-hint>
                                        <mat-error *ngIf="billingForm.get('simulatorCount')?.hasError('required')">Simulator count is required</mat-error>
                                        <mat-error *ngIf="billingForm.get('simulatorCount')?.hasError('min')">Must be at least 1</mat-error>
                                        <mat-error *ngIf="billingForm.get('simulatorCount')?.hasError('max')">Cannot exceed {{ getMaxSimulatorCount() }}</mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="mb-3">
                                    <label class="mb-2 fw-bold">Credit Card</label>
                                    <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
                                        <ngx-stripe-card [options]="cardOptions" (change)="onCardChange($event)" />
                                    </ngx-stripe-elements>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <button mat-button matStepperPrevious [disabled]="isLoading">Back</button>
                                    <button mat-raised-button type="submit" [disabled]="!billingForm.valid || !isCardValid || isLoading">
                                        Sign Up & Subscribe
                                    </button>
                                </div>
                            </form>
                        </mat-step>
                    </mat-horizontal-stepper>
                </mat-card>
            </div>
        </div>
    </div>
</div>